import { Eyebrow, Reveal } from "./utils";

const principles = [
  { title: "Understand First", copy: "Every business has a different bottleneck." },
  { title: "Recommend Responsibly", copy: "The right next move is not always more marketing." },
  { title: "Build for People", copy: "Growth should create more control—not more chaos." },
];

export default function Philosophy() {
  return (
    <section data-testid="philosophy-section" className="relative overflow-hidden bg-brand-charcoal py-24 md:py-32">
      <div className="grain-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-0 h-[360px] w-[700px] rounded-full bg-brand-gold/8 blur-[140px]" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>The Apex Flow Standard</Eyebrow></Reveal>
          <Reveal delay={1}>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl tracking-tight text-white leading-[1.08]">
              People Over Profits. <span className="gold-text">Strategy Before Tactics.</span>
            </h2>
          </Reveal>
          <Reveal delay={2}>
            <div className="mt-7 space-y-4 font-sans text-base md:text-lg leading-relaxed text-white/60">
              <p>
                Apex Flow does not recommend ads, software, automations, or a higher-tier package unless it genuinely fits
                a business’s actual needs, capacity, and goals.
              </p>
              <p>The goal is not to add more moving parts.</p>
              <p>
                The goal is to create more clarity, stronger systems, better follow-up, and a more predictable path to
                growth.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {principles.map((p, i) => (
            <Reveal key={p.title} delay={i}>
              <div className="group h-full rounded-2xl glass-dark p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand-gold/40">
                <span className="font-mono text-sm text-brand-gold">0{i + 1}</span>
                <h3 className="mt-4 font-serif text-2xl tracking-tight text-white">{p.title}</h3>
                <p className="mt-3 font-sans text-[15px] leading-relaxed text-white/55">{p.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={1} className="mt-20 text-center">
          <h3 className="font-serif text-3xl md:text-5xl tracking-tight text-white leading-tight">
            Purpose-Driven Growth.<br className="hidden sm:block" /> <span className="gold-text">Built Around People.</span>
          </h3>
        </Reveal>
      </div>
    </section>
  );
}
